import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("arete_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  const method = (cfg.method || "get").toLowerCase();
  if (!navigator.onLine && !["get", "head", "options"].includes(method)) {
    return Promise.reject({
      isOffline: true,
      response: { data: { detail: "Sei offline: operazione non eseguita. Riprova quando torni online." } },
    });
  }
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && localStorage.getItem("arete_token")) {
      localStorage.removeItem("arete_token");
      const p = window.location.pathname;
      if (p.startsWith("/dashboard") || p.startsWith("/admin")) window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function apiError(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default api;
export { API };
